import React from "react";
import './PaginationBar.scss';

const MAX_PAGE_PAGINATED_ITEMS = 5;

const getPaginationItems = (totalResults, offset, limit) => {
  const items = [];
  if (offset > 0) {
    items.push(
      { label: '«', ...(offset > 0 ? { offset: 0 } : {}) },
      { label: '‹', ...(offset > 0 ? { offset: Math.max(0, offset - limit) } : {}) }
    )
  }
  const currentPage = Math.floor(offset / limit);
  const totalPages = Math.ceil(totalResults / limit);
  if (totalPages > MAX_PAGE_PAGINATED_ITEMS + 2) {
    const negativeOffset = Math.max(-2, 0 - currentPage);
    const positiveOffset = Math.min(2, totalPages - (currentPage + negativeOffset + MAX_PAGE_PAGINATED_ITEMS - 1));
    if (currentPage + negativeOffset > 0) {
      items.push(
        { label: '1', offset: 0 }
      );
      if (currentPage + negativeOffset > 1) {
        items.push({ label: '...', text: true });
      }
    }
    for (let pageIndex = currentPage + negativeOffset; pageIndex <= currentPage + positiveOffset; pageIndex++) {
      items.push(
        { label: (pageIndex + 1).toString(), ...(pageIndex !== currentPage ? { offset: pageIndex * limit } : {}), ...(pageIndex === currentPage ? { selected: true } : {}) }
      );
    }
    if (currentPage + positiveOffset < totalPages - 1) {
      if (currentPage + positiveOffset < totalPages - 2) {
        items.push(
          { label: '...', text: true }
        );
      }
      items.push(
        { label: totalPages.toString(), ...(currentPage === totalPages - 1 ? { selected: true } : { offset: (totalPages - 1) * limit }) }
      );
    }
  } else {
    for (let pageIndex = 0; pageIndex < totalPages; pageIndex++) {
      items.push(
        { label: (pageIndex + 1).toString(), ...(pageIndex !== currentPage ? { offset: pageIndex * limit } : {}), ...(pageIndex === currentPage ? { selected: true } : {}) }
      );
    }
  }
  if (currentPage < totalPages - 1) {
    items.push(
      { label: '›', offset: (currentPage + 1) * limit },
      { label: '»', offset: (totalPages - 1) * limit }
    );
  }
  return items;
};

const getPaginationItemClass = (item) => {
  if (item.selected) {
    return { className: 'selected' };
  } else if (! ('offset' in item) && ! item.text) {
    return { className: 'disabled' };
  } else if (item.text) {
    return { className: 'text' };
  } else {
    return {};
  }
};

const PaginationBar = ({ totalResults, searchParams, defaultLimit, setPagination, anchor }) => {
  const offset = searchParams.has('offset') ? parseInt(searchParams.get('offset')) : 0;
  const limit = searchParams.has('limit') ? parseInt(searchParams.get('limit')) : defaultLimit;
  const paginationItems = getPaginationItems(totalResults, offset, limit);
  return (
    <div className="PaginationBar">
      {paginationItems.map((item, index) =>
        <button
          key={index}
          {...getPaginationItemClass(item)}
          onClick={() => {
            if (! ('offset' in item)) { return; }
            setPagination({ offset: item.offset });
            anchor.current?.scrollIntoView({ behavior: 'smooth' });
          }}
        >{item.label}</button>
      )}
    </div>
  );
};

export default PaginationBar;
